import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Markdown from 'markdown-to-jsx';
import styles from './MarkdownModal.module.css';

interface MarkdownModalProps<T> {
  show: boolean;
  onHide: () => void;
  item: T | null;
  getItemTitle: (item: T) => string;
  content: string | null;
  isLoading: boolean;
  modalTitle?: string;
  loadingText?: string;
}

function MarkdownModal<T>({
  show,
  onHide,
  item,
  getItemTitle,
  content,
  isLoading,
  modalTitle,
  loadingText = 'Loading...'
}: MarkdownModalProps<T>) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      className={styles.modal}
      dialogClassName={styles.dialog}
      style={{ zIndex: 10000 }}
      backdropClassName="modal-backdrop"
    >
      <Modal.Header closeButton className={styles.header}>
        <Modal.Title className={styles.title}>
          <span className={styles.titleGradient}>
            <FontAwesomeIcon className="mr-2" icon={["fal", "sparkles"]} />
            {modalTitle}
          </span>
          <span className={styles.itemTitle}>
            {item ? getItemTitle(item) : ''}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.body}>
        {isLoading ? (
          <div className={styles.loadingContainer}>
            <div className={styles.loadingProgress}>
              <div className={styles.loadingProgressBar} />
            </div>
            <div className={styles.loadingText}>{loadingText}</div>
          </div>
        ) : (
          <div className={`${styles.markdownContent} ${styles.content}`}>
            <Markdown>{content || ''}</Markdown>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className={styles.footer}>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default MarkdownModal; 